import { Map, OrderedMap, fromJS } from 'immutable';

import WorkspaceItemCommentsConstants from '../constants/WorkspaceItemComments.constants';
import WorkspaceRecentUpdatesConstants from '../constants/WorkspaceRecentUpdates.constants';

const initialState = Map({
  [WorkspaceItemCommentsConstants.State.WORKSPACE_ITEM_COMMENTS_BY_MEETING_ITEM_SLUG]: OrderedMap(),
});

export const WorkspaceItemCommentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case WorkspaceItemCommentsConstants.Actions.FETCH_WORKSPACE_ITEM_COMMENTS_SUCCESS:
    case WorkspaceItemCommentsConstants.Actions.CREATE_WORKSPACE_ITEM_COMMENT_SUCCESS:
    case WorkspaceItemCommentsConstants.Actions.UPDATE_WORKSPACE_ITEM_COMMENT_SUCCESS:
    case WorkspaceRecentUpdatesConstants.Actions.FETCH_RECENT_UPDATES_SUCCESS:
      return state.updateIn(
        [WorkspaceItemCommentsConstants.State.WORKSPACE_ITEM_COMMENTS_BY_MEETING_ITEM_SLUG],
        (existing = OrderedMap()) =>
          existing.merge(
            OrderedMap(
              Object.values(action.payload.workspaceComments).map(item => [
                item.attributes.uuid,
                Map(fromJS(item.attributes)),
              ])
            )
          )
      );
    case WorkspaceItemCommentsConstants.Actions.DELETE_WORKSPACE_ITEM_COMMENT_SUCCESS:
      return state.deleteIn([
        WorkspaceItemCommentsConstants.State.WORKSPACE_ITEM_COMMENTS_BY_MEETING_ITEM_SLUG,
        action.payload,
      ]);
    default:
      return state;
  }
};
